import React from "react";
import { Text } from "../../../components";

export const dfi = {
  title: "Danos físicos ao imóvel (DFI)",
  body: (
    <>
      <Text>
        A cobertura DFI é para deixar seu imóvel bem cuidado. Já parou pra
        pensar o quanto você gastaria com alguma obra ou reparo, caso
        acontecesse algo inesperado com o imóvel que você está financiando? Caso
        ocorra algum imprevisto que esteja previsto no seu contrato, nós
        indenizaremos o valor necessário para repor os prejuízos e deixar o seu
        imóvel do mesmo jeito que ele era quando você comprou.
      </Text>
      <Text>
        É importante que você saiba que vícios construtivos, uso e desgaste
        natural e falta de manutenção não são indenizáveis.
      </Text>
      <Text>Confira abaixo as coberturas que compõem o DFI:</Text>
      <Text>
        <li>Incêndio</li>
        Se ocorrer um incêndio acidental no imóvel, essa cobertura cobre a
        reparação dos danos e prejuízos ao imóvel.
      </Text>
      <Text>
        <li>Queda de Raio</li>
        Se um raio cair no terreno de sua casa ou edifício, essa cobertura cobre
        os reparos do imóvel.
      </Text>
      <Text>
        <li>Explosão</li>
        Em caso de explosão, essa cobertura cobre o reparo dos prejuízos.
      </Text>
      <Text>
        <li>Vendaval</li>
        Cobre o pagamento dos prejuízos no imóvel, causados por um vendaval -
        conforme especificação no seu contrato de seguro.
      </Text>
      <Text>
        <li>Destelhamento</li>
        Seu imóvel foi destelhado depois de uma forte chuva, por exemplo? Essa
        cobertura cobre a reposição dos telhados danificados do seu imóvel.
      </Text>
      <Text>
        <li>Desmoronamento ou ameaça de desmoronamento</li>A parede caiu, a laje
        desabou, a coluna ou a marquise está comprometida? Essa cobertura cobre
        o reparo dos danos causados ao imóvel devido a desmoronamento ou ameaça,{" "}
        <strong>
          desde que esses eventos não tenham sido causados por falhas ou vícios
          construtivos.
        </strong>
      </Text>
      <Text>
        <li>Alagamento</li>
        Seu imóvel foi alagado por uma forte chuva, o rio transbordou ou alguma
        tubulação que não pertence ao seu imóvel se rompeu? Com essa cobertura
        nós te indenizamos para cobrir os danos causados pelo alagamento.
      </Text>
    </>
  ),
};

export default null;
